import { render, staticRenderFns } from "./CSU.vue?vue&type=template&id=453a222b"
import script from "./CSU.vue?vue&type=script&lang=js"
export * from "./CSU.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports